import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { menuFetchList } from './menuFetchList';

import { IMenuStore } from '../../types';
import { IActionMenuFetchListPayloadDone } from './types';

export const menuFetchListReducer = (menu: ReducerBuilder<IMenuStore, IMenuStore>) => {
	applyAsyncReducer<IMenuStore['menu']['data'], IMenuStore['menu']['meta']>()(
		'menu',
		'networkStatus',
		menuFetchList.async,
		menu,
		(props: { result: IActionMenuFetchListPayloadDone }) => ({
			list: props.result.menu,
		}),
	);
};
